export default "__VITE_ASSET__DILTBCIA__"